<script>
  import { getSortByString, getSortByNumber } from '../utils/sorters';
  import Modal from './Modal.svelte';
  import TableKey from './TableKey.svelte';
  import ReportButton from './ReportButton.svelte';
  import Pagination from './Pagination.svelte';
  import RoboText from './RoboText.svelte';
  import FindingTable from './FindingTable.svelte';
  // the hook for supplied props
  export let data;

  export let showModal = false;

  let modalData = {};
  function openModal(rowData) {
      showModal = true;
      modalData = rowData;
  }

  $: filteredData = data;

  // PAGINATION 
  const limit = 10;
  let currentPage = 1;
  let totalPages = 1;

  // Update total pages whenever filteredData changes
  $: totalPages = Math.ceil(filteredData.length / limit);

  // Ensure current page is within the new total pages
  $: if (currentPage > totalPages) currentPage = totalPages;


  // Filter table
  let searchTerm = '';
  function filterRows(e) {
      const value = e.target.value;
      searchTerm = value;
      if (value == '') {
          filteredData = data;
      } else {
          filteredData = data.filter(
              (d) => d.brand.toUpperCase().indexOf(value.toUpperCase()) > -1 || d.flavor.toUpperCase().indexOf(value.toUpperCase()) > -1
          );
      }
      currentPage = 1;
  }
  function resetInput() {
    searchTerm = ''; // Clear the input field
    filteredData = data; // Reset filtered data to the original dataset
    currentPage = 1; // Reset to the first page
  }


  $: headerList = [
  { text: 'Product', class: 'text-left sortable', attr: 'brand' },
  { text: 'Finding', class: 'text-center sortable', attr: 'finding' },
  // boolean columns
  { text: 'Exceeds state&nbsp;limits', class: 'text-center sortable', attr: 'regulated_pesticides' },
  { text: 'Off-list pesticides', class: 'text-center sortable', attr: 'unchecked_pesticides' },
  { text: 'Other risks', class: 'text-center sortable', attr: 'harmful_oil_bool' },
  // link
  // { text: 'View full report', class: 'text-center', attr: 'report' },
  ];

  $: tableRows = (d) => ({
  brand: d.brand,
  flavor: d.flavor,
  batch: d.batch,
  source: d.product_source,
  expanded_test: d.expanded_test,
  class: 'text-left',
  finding: d.finding.toLowerCase(),
  finding2: d.finding2.toLowerCase(),
  lab: d.testing_lab,
  batch_date: d.batch_date,
  oil: d.harmful_oil,
  regulated_pesticides: d.regulated_pesticides,
  unchecked_pesticides: d.unchecked_pesticides,
  regulated_pesticides_factor: d.regulated_pesticides_factor,
  unchecked_pesticides_factor: d.unchecked_pesticides_factor,
  removed_from_sale: d.removed_from_sale,
  removed_from_sale_date: d.removed_from_sale_date,
  days_on_market: d.days_on_market,
  sort: d.brand,
  pesicidesList: [
      d.pesticides
  ],
  // additional table values here
  values: [
    {
      text: d.regulated_pesticides_factor,
      class: 'text-center circle sortable',
      attr: 'regulated_pesticides_factor'
    },
    {
      text: d.unchecked_pesticides_factor,
      class: 'text-center circle sortable',
      attr: 'unchecked_pesticides_factor'
    },
    {
      text: d.harmful_oil_bool,
      class: 'text-center circle sortable',
      attr: 'harmful_oil_bool'
    },          
  ],    
  });

  const getTableRows = (arr, attr, order) => {
  // Sort the data
  const sortFunc =
    ['brand', 'finding', 'regulated_pesticides_factor', 'unchecked_pesticides_factor', 'harmful_oil_bool'].includes(attr)
      ? getSortByString(attr, order)
      : getSortByNumber(attr, order);
  arr.sort(sortFunc);

  // Return the array formatted for our template
  return arr.map(tableRows);
  };

  // computed values

  $: rowList = getTableRows(filteredData, sortAttr, sortAscending);


  // Pagination slice
  $: paginatedData = rowList.slice((currentPage - 1) * limit, currentPage * limit);


  // Sort controls
  let sortAttr = 'brand'; 
  let sortAscending = true;

  function onSort(clickedAttr) {
    if (sortAttr === clickedAttr) {
      sortAscending = !sortAscending;
    } else {
      sortAttr = clickedAttr;
      sortAscending = true;
    }
  }

  // key
  const keyItems = {
      "fail": {
          imgId: "red",
          imgAlt: "red X icon",
          imgUrl: "https://ca-times.brightspotcdn.com/56/6c/05eda54946eb925ec092e98c32e9/dw-dirty-75.png",
          description: "Exceeded California limit"
      },
      "pesticides": {
          imgId: "yellow",
          imgAlt: "yellow warning triangle icon",
          imgUrl: "https://ca-times.brightspotcdn.com/66/7a/edb6cc0d491b8925092c9246a683/dw-alert-b-75.png",
          description: "Pesticides detected"
      },
      "nodetect": {
          imgId: "green",
          imgAlt: "green check mark icon",
          imgUrl: "https://ca-times.brightspotcdn.com/e6/01/9fd48f9041819f43aefaf8abd7f6/dw-clean-75.png",
          description: "Pesticides not quantifiable or detected"
      }
  }; 

</script>
  <TableKey {keyItems}></TableKey>

  <div class="dg-table--inputs button-grid">

    <div class="button-grid-group search-box">
      <!-- <label for="lookup-table-input">Search by brand or product</label> -->
      <input
          class="search"
          style="display: block;"
          id="lookup-table-input"
          on:keyup={filterRows}
          value={searchTerm}
          placeholder="Search by brand or product"
      />
      {#if searchTerm}
      <button class="reset" aria-label="Clear search input." on:click={resetInput}></button>
      {/if}
    </div>
    <div class="button-grid-group">
        <Pagination {totalPages} currentPage={currentPage} on:change={(event) => currentPage = event.detail} />
    </div>
  </div>
  <table class="dg-table">
    <thead>
      <tr>
      {#each headerList as obj}
        {#if obj.attr == 'report'}
        <th
          scope="col"
          data-attr={obj.attr}
          class={obj.class}
        >
          {@html obj.text}
        </th>
        {:else}        
        <th
          scope="col"
          role="columnheader"
          data-attr={obj.attr}
          class={obj.class}
          class:sort-asc={sortAttr === obj.attr && sortAscending}
          class:sort-desc={sortAttr === obj.attr && !sortAscending}
          on:click={onSort(obj.attr)}
        >
          {@html obj.text}
        </th>
        {/if}
      {/each}
      </tr>
    </thead>
    <tbody>
		{#each Object.values(paginatedData) as row, idx}
            
			<tr class={row.finding}>
        <th
            scope="row" role="rowheader" class={row.class}>
            <p class="brand">{row.brand}{#if row.expanded_test !== 'y' }*{/if}<br>
            <p class="product">{row.flavor}</p>
            {#if row.batch}<small class="batch ellipsis">{row.batch}</small>{/if}
            {#if row.source}{#if row.batch}<br/>{/if}<small class="caveat">({row.source})</small>{/if}
        </th>
        <td class="finding text-center">
          <ReportButton
                on:openModal={(event) => openModal(row)}
                {row}
                {keyItems}
            />
            
        </td>
        {#each Object.values(row.values) as cell, idx}
          <td class="{cell.class}">
              {#if cell.text }
                  ● 
              {/if}
          </td>
        {/each}
			</tr>
		{/each}
    </tbody>
  </table>

  <Pagination {totalPages} currentPage={currentPage} on:change={(event) => currentPage = event.detail} />

<Modal 
    bind:showModal={showModal}
>
    <div slot="header" class="header">
        <div class="product-details">
          <h2 class="brand">{modalData.brand}</h2>
          <h3 class="product">{modalData.flavor}</h3>
          {#if modalData.batch}<p class="batch">Batch No.: {modalData.batch}</p>{/if}
          <p class="finding">
            <span class="result-icon ">
              <img src="{ keyItems[modalData.finding]?.imgUrl }" alt="{ keyItems[modalData.finding]?.imgAlt }"/>
            </span>
            { keyItems[modalData.finding]?.description }
          </p>
        </div>
    </div>
    <div slot="body" class="modal-copy">
      <RoboText {modalData} />
    </div>
    <div slot="pesticides" class="pesticides-list">
        {#if modalData.regulated_pesticides + modalData.unchecked_pesticides > 0}
            <p class="table-label">Standard</p>
            <div class="table-key">
              {#if modalData.regulated_pesticides > 0}
                <div class="key-item">
                    <div class="square ca"></div>
                    <p>California Department of Cannabis</p>
                </div>
              {/if}
              {#if modalData.unchecked_pesticides > 0}
                <div class="key-item">
                  <div class="square epa"></div>
                  <p>U.S. EPA*</p>
              </div>
              {/if}
            </div>

            <FindingTable {modalData}></FindingTable>

            <p class="footnote">
              Values containing a {'<'} symbol were measured below quantification levels. 
            </p>
            {#if modalData.unchecked_pesticides > 0}
              <p class="footnote">
                *No maximum residue level but the U.S. Environmental Protection Agency requires additional research when evaluating pesticides for use on tobacco that exceed residues of 100 ppb.
              </p>
            {/if}
        {/if}
    </div>
</Modal>
